package com.merkost.handpass.admin.contract

import com.merkost.handpass.api.dto.admin.AdminQueueItem
import com.merkost.handpass.api.dto.admin.SavedView
import pro.respawn.flowmvi.api.MVIAction
import pro.respawn.flowmvi.api.MVIIntent
import pro.respawn.flowmvi.api.MVIState

data class QueueState(
    val source: QueueSourceFilter = QueueSourceFilter.ALL,
    val sort: QueueSortFilter = QueueSortFilter.NEWEST,
    val reason: String? = null,
    val view: QueueViewFilter? = null,
    val page: Int = 1,
    val totalPages: Int = 1,
    val totalCount: Long = 0L,
    val data: AsyncSection<List<AdminQueueItem>> = AsyncSection.Loading,
    val selectedIds: Set<String> = emptySet(),
    val savedViews: List<SavedView> = emptyList(),
) : MVIState

enum class QueueSourceFilter(val wire: String) { ALL("ALL"), REPORTS("REPORTS"), ACTIVE("ACTIVE") }
enum class QueueSortFilter(val wire: String) { NEWEST("NEWEST"), OLDEST("OLDEST"), MOST_REPORTED("MOST_REPORTED"), REPEAT_OFFENDERS("REPEAT_OFFENDERS") }
enum class QueueViewFilter(val wire: String) { URGENT("URGENT") }

sealed interface QueueIntent : MVIIntent {
    data class SetSource(val source: QueueSourceFilter) : QueueIntent
    data class SetSort(val sort: QueueSortFilter) : QueueIntent
    data class SetReason(val reason: String?) : QueueIntent
    data class SetView(val view: QueueViewFilter?) : QueueIntent
    data class GoToPage(val page: Int) : QueueIntent
    data class ToggleSelect(val id: String) : QueueIntent
    data object ToggleSelectAllVisible : QueueIntent
    data object ClearSelection : QueueIntent
    data class TapItem(val item: AdminQueueItem) : QueueIntent
    data class TapBulkAction(val kind: QueueBulkActionKind) : QueueIntent
    data class ConfirmBulkAction(val kind: QueueBulkActionKind, val reason: String?) : QueueIntent
    data class SaveCurrentView(val name: String) : QueueIntent
    data class ApplySavedView(val view: SavedView) : QueueIntent
    data class DeleteSavedView(val viewId: String) : QueueIntent
    data class LoadSavedViews(val views: List<SavedView>) : QueueIntent
    data class ReactToFocusTick(val tick: Long) : QueueIntent
    data object Refresh : QueueIntent
}

enum class QueueBulkActionKind { Dismiss, SuspendListing, WarnUser, SuspendUser, BanUser }

sealed interface QueueAction : MVIAction {
    data class Navigate(val path: String) : QueueAction
    data class OpenBulkConfirm(val kind: QueueBulkActionKind, val itemCount: Int) : QueueAction
    data class ShowSuccess(val message: String) : QueueAction
    data class ShowError(val message: String) : QueueAction
    data class ShowPartialSuccess(val successCount: Int, val failureCount: Int) : QueueAction
}
